import React, { useState } from 'react';
import styled from 'styled-components';

import TextareaField from '~fields/TextareaField';
import TagField from '~fields/TagField';
import CheckboxField from '~fields/CheckboxField';
import SpaceSelectField from '~fields/SpaceSelectField';
import PhoneField from '~fields/PhoneField';
import OpenHours from '../formik/components/OpenHours';
import PhotoAdder from '~components/form/PhotoAdder';

import QRCodeButton from '../components/QRCodeButton';

import { getTimeInfo } from '../../services/api.helpers';

const SpaceMaintenanceForm = props => {
  const {
    formId,
    formik: { setFieldValue, values },
  } = props;

  const [timeInfo, setTimeInfo] = useState();
  const [spaceQRReading, setSpaceQRReading] = useState();

  const updateTimeInfo = async opts => {
    const tempTimeInfo = await getTimeInfo(formId, opts);
    setTimeInfo(tempTimeInfo);
  };

  const handleQRCode = async text => {
    setSpaceQRReading(text);
  };

  const handlePhotoChange = photoProps => {
    if (!photoProps) {
      setFieldValue('attachmentInput', []);
      return;
    }

    const { id, photo } = photoProps;

    setFieldValue('attachmentInput', [{ id, photo }]);
  };

  return (
    <Container>
      <TagField
        required
        name="type"
        fallbackLabel="Palvelupyynnön kohde"
        onChange={value => updateTimeInfo({ type: value })}
      />

      {
        timeInfo && (
          <OpenHours
            timeInfo={timeInfo}
            urgency={{
              canBeUrgent: true,
              isUrgent: values.isUrgent,
            }}
          />
        ) // Show open hours depending on above choice
      }

      <SpaceSelectField
        required
        name="space"
        formId={formId}
        collapseType="phone"
        externalQRCodeReading={spaceQRReading}
      />

      <QRCodeButton onRead={handleQRCode} />

      <TextareaField
        name="description"
        fallbackLabel="Palvelupyyntö"
        rows={5}
        required
      />

      {!!window.cordova && (
        <PhotoAdder
          onPhotoChange={handlePhotoChange}
          photoData={
            (values.attachmentInput.length &&
              values.attachmentInput[0]?.photo) ||
            null
          }
        />
      )}

      {/* <CheckboxField name="collectFeedback" /> */}

      <PhoneField required fallbackLabel="Puhelinnumero" name="contactPhone" />

      <CheckboxField name="infectionRisk" />
    </Container>
  );
};

const Container = styled.div`
  & > * {
    margin-bottom: 24px;
  }
`;

export default SpaceMaintenanceForm;
